// extracted by mini-css-extract-plugin
module.exports = {"news_with_item":"newsWithImage-m__news_with_item__2UoSM"};